import { Grid } from '@mui/material'
import { I18NextNs, APIStatusCode } from 'enum/enum';
import moment from 'moment';
import { useEffect, useMemo, useState } from 'react'
import { useForm, FormProvider } from 'react-hook-form';
import { useLocation } from 'react-router';
import { RouterDOM, FnAxios, FnDialog, I18n, formatNumber } from 'utilities/utilities';
import { BtnBack, BtnDraft, BtnSave, BtnVersion } from 'components/Button/ButtonAll';
import { DatePickerItem } from 'components/Input/DatePicker/DatePickerItem';
import InputNumberItem from 'components/Input/InputNumber';
import TableIncomeMuseum from './TableIncomeMuseum';
import _ from "lodash";
import { numberFormatterLocale, parseFloatCheckValue } from '../Ticket/fnTickit';
import DialogVersion from './DialogVersion';
import DialogRadioVersion from './DialogRadioVersion';
import InputReactNumber from '../InputReactNumber';
import { GetMenuPermissionParamRoute } from 'utilities/SystemFunction';



const FundIncomePlanForm = () => {
    //#region Hook
    const Router = RouterDOM();
    const AxiosFn = FnAxios()
    const DialogFn = FnDialog();
    const location = useLocation();
    // #endregion

    const objParamPath = useMemo(() => {
        const ParamId = new URLSearchParams(location.search).get("strParam");
        const ParamPrs = 2;
        return { ParamId, ParamPrs }
    }, [location.search])

    //#region State / Usememo
    const [isPermission, setIsPermission] = useState<boolean>(false);
    const [modePlan, setModePlan] = useState("D")
    const [isVersion, setIsVersion] = useState(false)
    const arrQuater = useMemo(() => ["ไตรมาส 1", "ไตรมาส 2", "ไตรมาส 3", "ไตรมาส 4"], [])
    const arrMonth = useMemo(() => ["ม.ค.", "ก.พ.", "มี.ค.", "เม.ย.", "พ.ค.", "มิ.ย.", "ก.ค.", "ส.ค.", "ก.ย.", "ต.ค.", "พ.ย.", "ธ.ค."], [])
    const [lstMuseumIncome, setLstMuseumIncome] = useState([])
    const [lstMuseumIncomeVersion, setLstMuseumIncomeVersion] = useState([])
    const [isOpenVersion, setIsOpenVersion] = useState(false)
    const [isOpenRadio, setIsOpenRadio] = useState(false)

    const [option, setOption] = useState({
        lstVersion: [],
    })

    const [defaultValues, setDefaultValues] = useState({
        dYear: null,
        nVersionTotalYear: null,
        nTotalYear: null,
        isSaveVersion: null,
    })
    // #endregion

    //#region Form
    const form = useForm({
        shouldFocusError: true,
        shouldUnregister: false,
        mode: "all",
        defaultValues: defaultValues
    });

    // #endregion

    const getOptionInitialData = async () => {
        DialogFn.BlockUI();
        if (objParamPath.ParamId) {
            await AxiosFn.Get(`FundIncomePlan/GetFormInfoFundIncomePlan`, { sID: objParamPath.ParamId }, (result) => {
                DialogFn.UnBlockUI();
                let objResult = result.objResult;
                if (objResult) {
                    setModePlan(objResult.objIncome.sMode)
                    // setIsView(objResult.objIncome.sMode === "S")
                    setOption(opt => ({
                        ...opt,
                        lstVersion: objResult.lstOptionversion,
                    }))
                    setLstMuseumIncome(objResult.objIncome.lstIncomeMuseum)

                    form.setValue("dYear", moment().set('year', objResult.objIncome.nYear))
                    form.setValue("nTotalYear", objResult.objIncome.nTotalYear)
                    setDefaultValues(defaultValues => ({
                        ...defaultValues,
                        nTotalYear: objResult.objIncome.nTotalYear
                    }))
                }
            }, null, () => DialogFn.UnBlockUI());
            return;
        }
        await AxiosFn.Get(`FundIncomePlan/GetInitFormIncome`, { nYear: 0 }, (result) => {
            DialogFn.UnBlockUI();
            let objResult = result.objResult;
            setLstMuseumIncome(objResult.lstIncomeMuseum)
        }, null, () => DialogFn.UnBlockUI());
    };

    const handleSelectYear = async (eValue) => {
        if (!eValue){
             return;
            }
        DialogFn.BlockUI();
        let nYear = parseInt(moment(eValue).format('YYYY'));
        await AxiosFn.Get(`FundIncomePlan/GetInitFormIncome`, { nYear: nYear }, (result) => {
            DialogFn.UnBlockUI();
            if (result.nStatusCode === 203) {
                DialogFn.Warning("ข้อมูลประจำปี " + (nYear+543) + " ได้ถูกบันทึกไปแล้ว");
                form.setValue("dYear", null)
                return;
            }
        }, null, () => DialogFn.UnBlockUI());
    };


    const handleSubmitForm = (sMode) => {
        if (sMode === "S") {
            let nTotalInput = parseFloatCheckValue(form.getValues("nTotalYear"));
            let sumTotal = _.sumBy(lstMuseumIncome, function (o: any) { return parseFloatCheckValue(o.nTotal); });
            if (sumTotal !== nTotalInput) {
                let diff = formatNumber(nTotalInput - sumTotal,2);
                DialogFn.Warning("ไม่สามารถกดยืนยันได้ เนื่องจากผลรวมเทียบกับยอดรวมทั้งปีไม่เท่ากัน โดยมีส่วนต่าง " + diff);
                return;
            }
            if(objParamPath.ParamId && modePlan !== "D")
            {
                setIsOpenRadio(true)
            }else
            {
                handleSubmitIncome("S")
            }
            return;
        }
        handleSubmitIncome("D")
    }

    const handleSubmitIncome = (sMode) => {
        let nTotalInput = parseFloatCheckValue(form.getValues("nTotalYear"));
        let objParam = {
            "sMode": sMode,
            "sID": objParamPath.ParamId,
            "isSaveVersion": form.getValues("isSaveVersion") === "1",
            "nYear": form.getValues("dYear") ? parseInt(moment(form.getValues("dYear")).format('YYYY')) : null,
            "nTotalYear": nTotalInput,
            "lstIncomeMuseum": lstMuseumIncome
        };
        DialogFn.Submit(I18n.SetText("Message.ConfirmSave", I18NextNs.labelComponent), () => {
            AxiosFn.Post(`FundIncomePlan/OnSubmitFundIncomePlan`, objParam, (result) => {
                if (result.nStatusCode === APIStatusCode.Success) {
                    DialogFn.Success(I18n.SetText("Message.SaveComplete", I18NextNs.labelComponent), () => {
                        gotoBack();
                    });
                } else {
                    DialogFn.Warning(result.sMessage);
                }
            });
        });
    }

    const handleSelectVersion = (result) => {

        setIsVersion(true)
        form.setValue("nVersionTotalYear", result.nTotalYear)
        setLstMuseumIncomeVersion([...result.lstIncomeMuseum]);
        form.reset({
            ...form.watch(),
        });
        setIsOpenVersion(false)
    }

    const gotoBack = () => {
        if (isVersion) {
            setIsVersion(false)
            setLstMuseumIncome(value => [...value]);
            form.setValue("nTotalYear", defaultValues.nTotalYear)
            return;
        }
        Router.GoToPage("/FundIncomePlanList")
    }

    useEffect(() => {
        GetMenuPermissionParamRoute("/FundIncomePlanList", AxiosFn, setIsPermission, DialogFn);

        getOptionInitialData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <FormProvider {...form}>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Grid
                        container
                        spacing={2}
                        justifyContent={"space-between"}
                        alignItems={"start"}
                    >

                        <Grid item xs={12} md={9}>
                            <Grid
                                container
                                spacing={2}
                                justifyContent={"start"}
                                alignItems={"start"}
                            >
                                <Grid item xs={12} md={3}>
                                    <DatePickerItem
                                        id={`dYear`}
                                        name={`dYear`}
                                        label={`ประจำปี`}
                                        required
                                        fullWidth
                                        disabled={isVersion || !isPermission || !!objParamPath.ParamId}
                                        IsYearPicker
                                        format='YYYY'
                                        onChange={(eValue) => handleSelectYear(eValue)}
                                    />
                                </Grid>
                                <Grid item xs={12} md={3}>
                                    {
                                        isVersion ?
                                            <InputNumberItem
                                                id={`nVersionTotalYear`}
                                                name={`nVersionTotalYear`}
                                                label={'ยอดรวมทั้งปี'}
                                                ShowDigits={2}
                                                maxDigits={2}
                                                required={false}
                                                disabled
                                            />
                                            :
                                            <InputReactNumber
                                                id={`nTotalYear`}
                                                name={`nTotalYear`}
                                                label={'ยอดรวมทั้งปี'}
                                                ShowDigits={2}
                                                maxDigits={2}
                                                min={1}
                                                required
                                                disabled={!isPermission}
                                                IsCanMinus={false}
                                                onChange={(eValue) => {
                                                    setDefaultValues(defaultValues => ({
                                                        ...defaultValues,
                                                        nTotalYear: eValue
                                                    }))
                                                }}
                                            />}
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={"auto"}>
                            {
                                    modePlan !== "D" && option.lstVersion.length !== 0 ?
                                    <BtnVersion id={"btnversion"} onClick={() => setIsOpenVersion(true)} />
                                    : null
                            }
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    {
                        isVersion ?
                            <TableIncomeMuseum
                                keyId={"V_"}
                                lstIncome={lstMuseumIncomeVersion}
                                setlstIncome={setLstMuseumIncomeVersion}
                                arrQuater={arrQuater}
                                arrMonth={arrMonth}
                                isView={true}
                                isVersion={true}
                            />
                            :
                            <TableIncomeMuseum
                                keyId={"I_"}
                                lstIncome={lstMuseumIncome}
                                setlstIncome={setLstMuseumIncome}
                                arrQuater={arrQuater}
                                arrMonth={arrMonth}
                                isView={!isPermission}
                                isVersion={false}
                            />
                    }

                </Grid>
                <Grid item xs={12}>
                    {/* Button */}
                    <Grid
                        container
                        spacing={2}
                        justifyContent={"space-between"}
                        alignItems={"start"}
                    >
                        <Grid item>
                            <BtnBack id={"btnback"} onClick={() => gotoBack()} />
                        </Grid>
                        <Grid item>
                            {
                                !isPermission || isVersion ? null :
                                    <Grid
                                        container
                                        spacing={2}
                                        justifyContent={"end"}
                                        alignItems={"start"}
                                    >
                                        {modePlan === "D" && <Grid item>
                                            <BtnDraft
                                                id={"btndraft"}
                                                onClick={() => handleSubmitForm("D")}
                                            />
                                        </Grid>}
                                        <Grid item>
                                            <BtnSave
                                                id={"btnsave"}
                                                onClick={form.handleSubmit(() => handleSubmitForm("S"))}
                                            />
                                        </Grid>
                                    </Grid>}
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            <DialogRadioVersion
                isOpenRadio={isOpenRadio}
                setIsOpenRadio={setIsOpenRadio}
                form={form}
                handleSubmit={handleSubmitIncome}
            />
            <DialogVersion
                isOpenVersion={isOpenVersion}
                setIsOpenVersion={setIsOpenVersion}
                nYear={form.getValues("dYear")}
                option={option.lstVersion}
                handleSelectVersion={handleSelectVersion}
                isInCome={true}
            />
        </FormProvider>
    )
}

export default FundIncomePlanForm